import Image from 'next/image';

type Props = {
  title: string;
  description: string;
  coverImage: StaticImageData;
  profileImage: StaticImageData;
};

const Component: React.FC<Props> = ({
  title,
  coverImage,
  description,
  profileImage,
}) => (
  <div className="flex w-full flex-col rounded border border-gray-300">
    <div className="relative h-32 w-full rounded-t md:h-48">
      <Image fill alt={title} src={coverImage} className="object-cover" />
    </div>

    <div className="relative flex">
      <div className="absolute ml-3 mt-3 w-20 p-1 md:-mt-6 md:ml-10 md:w-28">
        <div className="aspect-square">
          <Image alt={title} src={profileImage} />
        </div>
      </div>

      <div className="ml-24 flex flex-col gap-y-1 px-2 py-5 md:ml-40 md:py-4">
        <div className="flex items-center gap-x-2">
          <h1 className="text-2xl">{title}</h1>
          <div className="h-fit w-fit rounded-sm bg-orange-500 px-1 text-sm font-bold leading-6 text-white">
            公式
          </div>
        </div>

        <div className="text-lg">{description}</div>
      </div>
    </div>
  </div>
);

export default Component;
